// Only attach once
if (!window.updateButtonListenerAttached) {
  window.updateButtonListenerAttached = true;

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[id^='ProductUpdateButton-']");
    if (!btn) return;

    while (window._pendingVariantFetch) {
      btn.classList.add("loading");
      try {
        await window._pendingVariantFetch;
      } catch (_) {}
    }
    btn.classList.remove("loading");

    btn.classList.add("loading");
    const spinner = btn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.remove("hidden");

    // ── Scope to container modal robustly ────────────────────────────────────
    const modal = btn.closest("quick-add-modal") || btn.closest(".quick-add-modal") || document;
    const qtyInput = modal.querySelector("[name='quantity']");
    const variantId = btn.dataset.variantId; // ← now guaranteed to be the latest resolved variant
    const quantity = qtyInput ? Number.parseInt(qtyInput.value, 10) : 1;
    const isCartEdit = modal.classList?.contains("quick-update-btn");
    const editQuantity = isCartEdit ? 1 : quantity;

    // get old variant id from hidden div

    let modalIsOpen = false;

    let variID = document.getElementById("old-variant-id");
    document.querySelectorAll(".quick-update-btn").forEach((radio) => {
      if (radio.hasAttribute("open")) {
        modalIsOpen = true;
        variID = radio.querySelector("#old-variant-id");
      }
    });

    const oldVariantDiv = modalIsOpen
      ? variID
      : document.getElementById("old-variant-id");

    const oldVariantId = oldVariantDiv
      ? oldVariantDiv.textContent.trim()
      : null;

    // ── helper: show error in the quickview variant error div ──────────────
    function showUpdateError(message) {
      // Prefer the error element scoped to the open modal's update area
      const errEl =
        (modal && modal !== document
          ? modal.querySelector(".product-form__error-message-wrapper-variant--update") ||
            modal.querySelector(".product-form__error-message-wrapper-variant")
          : null) ||
        document.querySelector(".product-form__error-message-wrapper-variant--update") ||
        document.querySelector(".product-form__error-message-wrapper-variant");

      if (errEl) {
        const span = errEl.querySelector("span");
        if (span) span.textContent = message;
        errEl.style.display = "block";
        setTimeout(() => {
          errEl.style.display = "none";
        }, 6000);
      }
    }
    // ──────────────────────────────────────────────────────────────────────

    // ── Stock guard: block if new variant already maxes out cart ──────────
    try {
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      // Only check if the new variant differs from the old one
      if (String(variantId) !== String(oldVariantId)) {
        const existingItem = cart.items.find(
          (item) => String(item.variant_id) === String(variantId)
        );

        if (existingItem) {
          // Read available stock from the quantity select in the modal
          const qtySelect = modal
            ? modal.querySelector("select[name='quantity']")
            : document.querySelector("select[name='quantity']");

          let availableStock = null;

          if (qtySelect) {
            const stockAttr = Number.parseInt(qtySelect.getAttribute("data-stock"), 10);
            if (!isNaN(stockAttr) && stockAttr > 0) {
              availableStock = stockAttr;
            } else {
              const opts = qtySelect.querySelectorAll("option");
              if (opts.length > 0) {
                availableStock = Number.parseInt(opts[opts.length - 1].value, 10) || null;
              }
            }
          }

          if (availableStock !== null) {
            const totalAfterUpdate = existingItem.quantity + quantity;
            if (totalAfterUpdate > availableStock) {
              const limitMsg = `We're sorry, you are limited to ${availableStock} of this item in the same color and size.`;
              showUpdateError(limitMsg);
              btn.classList.remove("loading");
              btn.removeAttribute("disabled");
              const earlySpinner = btn.querySelector(".loading__spinner");
              if (earlySpinner) earlySpinner.classList.add("hidden");
              const earlyText = btn.querySelector("span");
              if (earlyText) earlyText.style.visibility = "visible";
              return; // abort — do not update cart
            }
          }
        }
      }
    } catch (stockCheckErr) {
      console.warn("Stock check failed, proceeding with update:", stockCheckErr);
    }
    // ──────────────────────────────────────────────────────────────────────

    btn.disabled = true;

    // ── Helper: find a variant in the current cart by variant_id ─────────────
    function getCartEditLineIndex() {
      const modalId = modal?.id || "";
      const match = modalId.match(/-(?:cart|drawer)-(\d+)$/);
      return match ? Number.parseInt(match[1], 10) : null;
    }

    async function findCartLine(
      variantId,
      preferredLine = null,
      preferredKey = null,
    ) {
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      if (preferredKey) {
        const keyIndex = cart.items.findIndex((item) => item.key === preferredKey);
        if (keyIndex !== -1) {
          return { line: keyIndex + 1, cart, item: cart.items[keyIndex] };
        }
      }

      const preferredIndex = Number.isInteger(preferredLine)
        ? preferredLine - 1
        : -1;

      if (preferredIndex >= 0 && cart.items[preferredIndex]) {
        const item = cart.items[preferredIndex];
        if (!variantId || String(item.variant_id) === String(variantId)) {
          return { line: preferredIndex + 1, cart, item };
        }
      }

      const idx = cart.items.findIndex(
        (item) => String(item.variant_id) === String(variantId),
      );
      return idx === -1 ? null : { line: idx + 1, cart, item: cart.items[idx] };
    }

    // ── Step 1: Remove the old variant (set its quantity to 0) ───────────────
    async function reduceOldVariant(
      oldId,
      preferredLine = null,
      preferredKey = null,
    ) {
      const found = await findCartLine(oldId, preferredLine, preferredKey);
      if (!found) {
        console.warn("Old variant not found in cart — skipping remove:", oldId);
        return {};
      }
      const currentQuantity = Number.parseInt(found.item?.quantity, 10);
      const nextQuantity = Number.isFinite(currentQuantity)
        ? Math.max(0, currentQuantity - editQuantity)
        : 0;
      const changeBody = found.item?.key
        ? { id: found.item.key, quantity: nextQuantity }
        : { line: found.line, quantity: nextQuantity };

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(changeBody),
      });

      return found.item?.properties || {};
    }

    // ── Step 2: Add the new variant ──────────────────────────────────────────
    async function addNewVariant(newId, qty, properties = {}) {
      const cleanProperties = { ...(properties || {}) };
      if (!cleanProperties._unique_id && window.crypto?.randomUUID) {
        cleanProperties._unique_id = crypto.randomUUID();
      }

      const body = { id: newId, quantity: qty };
      if (Object.keys(cleanProperties).length) {
        body.properties = cleanProperties;
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        let errMsg = "Could not add updated variant";
        try {
          const errData = await res.json();
          if (errData?.description) errMsg = errData.description;
          else if (errData?.message) errMsg = errData.message;
        } catch (_) {}
        throw new Error(errMsg);
      }
      return res.json();
    }

    // ── Helper: show error inside the quickview/edit modal ───────────────────
    function showModalError(message, btnContext = null) {
      const cleanMsg = typeof message === "string" ? message.replace(/&#39;/g, "'") : message;
      // 1. Try the variant-level error element near the button
      const btnWrapper = btnContext?.closest(".product-form__update-buttons") || btnContext?.closest(".product-form__buy-buttons") || btnContext?.closest(".product-upate-price-flex") || modal;
      const variantErrEl = btnWrapper instanceof Document
        ? btnWrapper.querySelector(".product-form__error-message-wrapper-variant")
        : btnWrapper?.querySelector(".product-form__error-message-wrapper-variant");
      if (variantErrEl) {
        const span = variantErrEl.querySelector("span");
        if (span) span.textContent = cleanMsg;
        variantErrEl.style.display = "block";
        setTimeout(() => { variantErrEl.style.display = "none"; }, 6000);
        return;
      }
      // 2. Fallback: generic error wrapper
      const errWrapper = modal instanceof Document
        ? document.querySelector(".product-form__error-message-wrapper")
        : modal.querySelector(".product-form__error-message-wrapper");
      if (errWrapper) {
        const errMsg = errWrapper.querySelector(".product-form__error-message");
        if (errMsg) errMsg.textContent = cleanMsg;
        errWrapper.removeAttribute("hidden");
        errWrapper.style.display = "block";
        setTimeout(() => {
          errWrapper.setAttribute("hidden", "");
          errWrapper.style.display = "";
        }, 6000);
      }
    }

    try {
      const editLineIndex = getCartEditLineIndex();
      const oldLine = oldVariantId
        ? await findCartLine(oldVariantId, editLineIndex)
        : null;
      const oldProperties = oldLine?.item?.properties || {};

      // ── Pre-flight: check if the target variant is already at max stock in cart ──
      const cartRes = await fetch("/cart.js");
      const cartData = await cartRes.json();

      // Find whether the NEW variant is already in the cart (excluding the item being edited)
      const existingNewVariantItem = cartData.items.find(
        (item) => String(item.variant_id) === String(variantId)
          && (!oldLine || item.key !== oldLine.item?.key)
      );

      if (existingNewVariantItem) {
        // Read the max stock for the target variant from the quantity dropdown in the modal
        let maxStock = null;
        const qtySelect = (modal instanceof Document ? document : modal).querySelector('[name="quantity"]');
        if (qtySelect) {
          const stockAttr = Number.parseInt(qtySelect.dataset.stock, 10);
          if (!isNaN(stockAttr) && stockAttr > 0) {
            maxStock = stockAttr;
          } else {
            const opts = qtySelect.querySelectorAll("option");
            if (opts.length) maxStock = Number.parseInt(opts[opts.length - 1].value, 10) || null;
          }
        }

        // If the existing cart qty + edit quantity exceeds the stock limit, block the edit
        const currentCartQty = existingNewVariantItem.quantity;
        if (maxStock !== null && (currentCartQty + editQuantity) > maxStock) {
          const errMsg = `We're sorry, you are limited to ${maxStock} of this item in the same color and size.`;
          showModalError(errMsg, btn);
          btn.disabled = false;
          btn.classList.remove("loading");
          const spinnerRevert = btn.querySelector(".loading__spinner");
          if (spinnerRevert) spinnerRevert.classList.add("hidden");
          const textSpanRevert = btn.querySelector("span");
          if (textSpanRevert) textSpanRevert.classList.remove("hidden");
          return;
        }
      }
      // ─────────────────────────────────────────────────────────────────────────

      await addNewVariant(variantId, editQuantity, oldProperties);
      if (oldVariantId) {
        await reduceOldVariant(oldVariantId, editLineIndex, oldLine?.item?.key);
      }
      await updateCustomerCartMetafield();
    } catch (err) {
      console.error("Update failed:", err);

      const errMsg = err.message || '';
      const isMaxQtyError =
        /you can only add/i.test(errMsg) ||
        /maximum quantity/i.test(errMsg) ||
        /already in your cart/i.test(errMsg) ||
        /items? of this/i.test(errMsg) ||
        /reached the maximum quantity/i.test(errMsg) ||
        /sold out/i.test(errMsg);

      let displayMsg = errMsg;
      if (isMaxQtyError) {
        // Try to parse quantity from Shopify error message
        const parsedQty = (errMsg.match(/\b(\d+)\b/) || [])[1];

        // Read from quantity select inside the modal
        const qtySelect = (modal instanceof Document ? document : modal).querySelector('[name="quantity"]');
        let selectMax = null;
        if (qtySelect) {
          const stock = Number.parseInt(qtySelect.dataset.stock, 10);
          if (!isNaN(stock) && stock > 0) {
            selectMax = stock;
          } else {
            const options = qtySelect.querySelectorAll("option");
            if (options.length > 0) {
              selectMax = Number.parseInt(options[options.length - 1].value, 10) || null;
            }
          }
        }

        const maxQty = parsedQty || selectMax || 1;

        // Try reading variant limit message from dataset on the product-form element inside modal
        const productForm = (modal instanceof Document ? document : modal).querySelector('product-form');
        const variantBodyTpl = productForm?.dataset.variantLimitMessage || null;
        const variantBodyFallback = productForm?.dataset.variantLimitFallback || productForm?.dataset.cartLimitMessage || '';

        displayMsg = maxQty && variantBodyTpl
          ? variantBodyTpl.replace('__QTY__', maxQty)
          : variantBodyFallback || `We're sorry, you are limited to ${maxQty} of this item in the same color and size.`;
      }

      // Surface the error inside the modal
      showModalError(displayMsg || "Sorry, we couldn't update this item. Please try again.", btn);
      btn.disabled = false;
      btn.classList.remove("loading");
      const spinnerRevert = btn.querySelector(".loading__spinner");
      if (spinnerRevert) spinnerRevert.classList.add("hidden");
      const textSpanRevert = btn.querySelector("span");
      if (textSpanRevert) textSpanRevert.classList.remove("hidden");
      return;
    }

    // ── Step 3: Close modal + reload ─────────────────────────────────────────
    if (modal && modal.classList.contains("quick-add-modal")) {
      if (typeof modal.hide === "function") {
        modal.hide(true);
      } else if (typeof modal.close === "function") {
        modal.close();
      } else {
        modal.removeAttribute("open");
        modal.classList.remove("open");
      }
    }
    window.location.reload();
  });

  async function updateCustomerCartMetafield() {
    if (!window?.customer?.id) return; // Only run for logged-in users
    let currentCart = await fetch("/cart.js").then((res) => res.json());

    if (currentCart?.items?.length === 0) return;

    const cartData = {
      items: currentCart?.items.map((item) => ({
        variant_id: item?.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}, // line-item attributes
      })),
      attributes: currentCart.attributes || {}, // cart-level attributes
      note: currentCart.note || "",
    };

    const metaUpdateRes = await window.mapclubFetch('customer-cart-data', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: window.customer?.id,
        cartData,
      }),
    });
    const data = await metaUpdateRes.json();
    if (data) {
      // ✅ Safely extract new metafield value
      const newItemsData = data?.metafield?.value
        ? data.metafield.value
        : window.customer?.metafields?.cart?.itemsdata;

      // ✅ If you need it locally (for logic or display)
      window.customer = {
        ...window.customer,
        metafields: {
          ...window.customer?.metafields,
          cart: {
            ...window.customer?.metafields?.cart,
            itemsdata: newItemsData,
          },
        },
      };
    }
  }
}
